import React, {useEffect, useMemo, useState} from 'react';
import {ReactComponent as DoublechevronRight} from '../../assets/icons/max_right_pagination_arrow_icon.svg';
import {ReactComponent as DoublechevronLeft} from '../../assets/icons/max_left_pagination_arrow_icon.svg';
import {ReactComponent as ChevronRight} from '../../assets/icons/right_pagination_arrow_icon.svg';
import {ReactComponent as ChevronLeft} from '../../assets/icons/left_pagination_arrow_icon.svg';
import {ReactComponent as DoubleChevronUp} from '../../assets/icons/arrowDoubleUpIcon.svg';
import {ReactComponent as DoubleChevronDown} from '../../assets/icons/arrowDoubleDownIcon.svg';
import {ReactComponent as ChevronUp} from '../../assets/icons/arrowUpIcon.svg';
import {ReactComponent as ChevronDown} from '../../assets/icons/arrowDownIcon.svg';
import {useSelector} from 'react-redux';
import {IAppState} from '../../store/models';

// import {zoomIn} from '../../store/actionsCreator/zoomActionCreators';
import validator from "validator";
import {
    calculateCorrectPageFromShareLink,
    findCurrentTranslateLabel, getConvertedPageNumberToSlideNumber,
    scrollToPageForFlyer
} from "../globalsFunctions/globalFunctions";
import {isMobile, isTablet} from "react-device-detect";
import {Box, Button, Grid, Input, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import tinycolor from "tinycolor2";
import {useParams} from "react-router-dom";
import {ParamTypesDto} from "../../dtos/flyer";
// import useSound from "use-sound";
// import pageFlipSound from '../../assets/audio/page-flip-sound.wav'

const useStyles = makeStyles(() => ({
    paginationBox: {
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        height: `100%`
    },
    paginationBtn: {
        width: `36px`,
        height: `36px`
    },
    paginationWrapper: (props: any) => ({
        direction: 'ltr',
        '& .MuiTypography-root': {
            fontFamily: `${props.fontFamily}`,
            lineHeight: '1'
        },
        '& .MuiButton-root': {
            // minWidth: '40px',
            // width: '40px',
            // height: '40px',
            height: `100%`,
            width: `100%`,
            padding: '0',
            "& > svg path": {
                fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
            },
            '&:hover': {
                backgroundColor: '#ffffffBF',
                '& svg path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            },
            '&.Mui-disabled': {
                opacity: '0.5',
            }
        },
        '& .MuiInput-input': {
            backgroundColor: '#ffffff',
            fontFamily: `${props.fontFamily}`,
            padding: '2px',
            textAlign: 'center',
            fontSize: '18px',
            fontWeight: '700',
            borderRadius: '5px',
            border: `1px solid ${props.fontsGuiColor}`
        }
    }),

}))

type Props = {
    sliderRef?: any;
    setPageRangeInUrl?: (pageNumber: number) => void;
    // totalPages:any
}
// export const ContentForMobile: React.FC<Props> = ({calculateFlyerContainerHeightWidth, isDisplay}) => {
export const Pagination: React.FC<Props> = ({sliderRef, setPageRangeInUrl}) => {
    // console.log(totalPages);

    const {flyersBranch} = useSelector((state: IAppState) => state);
    const {data} = flyersBranch;
    const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const isLightGuiColor = tinycolor(flyerBasic?.primaryColorRgb).isLight();
    const fontsGuiColor = flyerBasic?.fontsColorRgb || "#000000";
    // const isMobile = useMediaQuery("(max-width:767px)", { noSsr: true });

    const {isFullScreen, isPortraitView} = useSelector((state: IAppState) => state.controlsBranch);
    // const {currentSlide} = useSelector((state: IAppState) => state.carouselBranch);
    const [isInputNumber, changeInputTypeToNumber] = useState<boolean>(false);
    const isHebrewStyle = data?.dir === "RTL";
    const {pageNumber} = useParams<ParamTypesDto>();
    //get lowest number in URL pages range
    const pageStringToNumberIndex = useMemo(() => calculateCorrectPageFromShareLink(pageNumber), [pageNumber]);
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    //convert page number to slide number
    const currentSlideNumber = useMemo(() => getConvertedPageNumberToSlideNumber(pageStringToNumberIndex, isMobile || isOnePageOrientation, (isHebrewStyle && !isVerticalScrolling && !isMobile), data?.pages)
        , [isMobile, isVerticalScrolling ,isOnePageOrientation, pageStringToNumberIndex, isHebrewStyle, data?.pages.length]);
    const [paginationValue, setPaginationValue] = useState<any>(currentSlideNumber);


    // const [pageFlip] = useSound(pageFlipSound)

    // const isVerticalScrolling = true;
    // const isOnePageOrientation: boolean = false;
    
    //translate captions
    const toFirstSlide = findCurrentTranslateLabel(110, "Go to First Page", data);
    const toLastSlide = findCurrentTranslateLabel(111, "Go to Last Page", data);
    const toNextSlide = findCurrentTranslateLabel(113, "Go to Next Page", data);
    const toPrevSlide = findCurrentTranslateLabel(112, "Go to Previous Page", data);
    const stylesProperties = {
        fontFamily: data?.font.toLowerCase(),
        direction: data?.dir.toLowerCase(),
        primaryColor: data?.primaryColorRgb ? data?.primaryColorRgb : `#C32E43`,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const classes = useStyles(stylesProperties);

    // const resetZooming = () => {
    //     dispatch(zoomIn({x: 0, y: 0, pivotX: 0, pivotY: 0, scale: 0}));
    // }

    useEffect(() => {
        if (data) {
            const pageNumber = renderCountForInput();
            setPaginationValue(pageNumber);
        }
    }, [currentSlideNumber]);

    const sortInputNumbers = (e: any) => {
        const targetValue = e.target.value;
        if (targetValue !== "" && validator.isNumeric(targetValue)) {
            changeInputTypeToNumber(true);
            const totalPages = data?.pages.length;
            const pressedNums = Number(e.target.value);
            if (validator.isNumeric(e.target.value)) {
                if (pressedNums > totalPages!) {
                    // setPaginationValue(totalPages!);
                } else if (pressedNums <= 0) {
                    setPaginationValue(1);
                } else {
                    setPaginationValue(pressedNums);
                }
            } else {
                setPaginationValue(paginationValue);
            }
        } else if (targetValue === '') {
            setPaginationValue('');
        } else {
            setPaginationValue(paginationValue);
        }
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const invalidChars = ["-", "+", "e", "E", ".", ",", "!", "@", "#", '/']; //include "." if you only want integers
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
            return;
        }
        if (e.key === "Enter" && paginationValue) {
            const newPage = Number(paginationValue)
            console.log(newPage);
            goToPage(newPage)
            const target = (e.target as HTMLElement);
            target.blur();
            return newPage;
        }
    }


    const goToPage = (pageNum: number) => {
        const totalPages = data?.pages.length;
        console.log(totalPages, 'totalPages');
        console.log(pageNum, 'pageNum');
        let newTotalPages = Math.floor(totalPages! / 2) + 1;
        // let newTotalPages =totalPages;
        let newPageNum = Math.floor(pageNum / 2);
        if (isOnePageOrientation) {
            newTotalPages = totalPages!;
            newPageNum = pageNum - 1;
        }
        console.log(newPageNum, 'newPageNum');
        let pageIndex = newPageNum;
        console.log(pageIndex, 'pageIndex');
        if (isHebrewStyle && !isVerticalScrolling) {
            pageIndex = newTotalPages - newPageNum - 1;
        }
        // console.log(pageIndex);
        if (isVerticalScrolling) {
            onScrollToPage(pageIndex);
            // dispatch(changeCarouselActiveSlide(pageIndex));
        } else {
            if(sliderRef){
                (sliderRef.current as any).slickGoTo(pageIndex);
            }
            // dispatch(changeCarouselActiveSlide(pageIndex));
        }

        return pageIndex;
    }
    let disabledNextButtons = false;
    let disabledPrevButton = false;
    if (currentSlideNumber === 0) {
        if (isHebrewStyle && !isVerticalScrolling) {
            disabledNextButtons = true;
        } else {
            disabledPrevButton = true;
        }
    }
    if (data) {
        if (isVerticalScrolling) {
            if (!isOnePageOrientation) {
                if (currentSlideNumber * 2 === data!.pages.length || data!.pages.length - currentSlideNumber * 2 === 1) {
                    disabledNextButtons = true;
                }
            } else {
                if (currentSlideNumber + 1 === data!.pages.length) {
                    disabledNextButtons = true;
                }
            }

        } else if (!isHebrewStyle) {
            if (!isOnePageOrientation) {
                if (currentSlideNumber * 2 === data!.pages.length || data!.pages.length - currentSlideNumber * 2 === 1) {
                    disabledNextButtons = true;
                }
            } else {
                if (currentSlideNumber + 1 === data!.pages.length) {
                    disabledNextButtons = true;
                }
            }
        } else {
            if (!isOnePageOrientation) {
                if (currentSlideNumber * 2 === data!.pages.length || data!.pages.length - currentSlideNumber * 2 === 1) {
                    disabledPrevButton = true;
                }
            } else {
                if (currentSlideNumber + 1 === data!.pages.length) {
                    disabledPrevButton = true;
                }
            }
        }
    }
    const renderCountForInput = () => {
        if (isMobile || (isVerticalScrolling && isOnePageOrientation)) {
            return `${currentSlideNumber + 1}`
        } else if (isVerticalScrolling && !isOnePageOrientation) {
            if (currentSlideNumber === 0) {
                if(data!.pages.length === 2){
                    return `${currentSlideNumber + 1}-${data!.pages.length}`;
                }
                return `${currentSlideNumber + 1}`;
                // } else if (currentSlideNumber * 2 === data!.pages.length) {
                //     return `${currentSlideNumber * 2}-${data!.pages.length}`;
            } else if (currentSlideNumber * 2 >= data!.pages.length) {
                return `${data!.pages.length}`;
            } else {
                return `${currentSlideNumber * 2}-${currentSlideNumber * 2 + 1}`;
            }
        } else {
            if (!isHebrewStyle) {
                if (!isOnePageOrientation) {
                    if (currentSlideNumber === 0) {
                        if(data!.pages.length === 2){
                            return `${currentSlideNumber + 1}-${data!.pages.length} / ${data!.pages.length}`;
                        }
                        return `${currentSlideNumber + 1}`;
                        // } else if (currentSlideNumber * 2 === data!.pages.length) {
                        //     return `${currentSlideNumber * 2}-${data!.pages.length}`;
                    } else if (currentSlideNumber * 2 >= data!.pages.length) {
                        return `${data!.pages.length}`;
                    } else {
                        return `${currentSlideNumber * 2}-${currentSlideNumber * 2 + 1}`;
                    }
                } else {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length}`
                    }
                    return `${currentSlideNumber + 1}`
                }
            } else {
                if (!isOnePageOrientation) {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length}`
                    } else if (data!.pages.length === 2) {
                        return `${currentSlideNumber + 1}-${data!.pages.length} / ${data!.pages.length}`;
                    } else if (currentSlideNumber === 0 && data!.pages.length === 1) {
                        return `${data!.pages.length - currentSlideNumber * 2}`;
                    } else if (currentSlideNumber * 2 === data!.pages.length) {
                        return `${(data!.pages.length - currentSlideNumber * 2) === 0 ? 1 : data!.pages.length - currentSlideNumber * 2}`;
                    } else if (currentSlideNumber === 0 && data!.pages.length % 2 !== 1) {
                        return `${data!.pages.length}`;
                    } else if (currentSlideNumber === 0 && data!.pages.length % 2 === 1) {
                        return `${data!.pages.length - (currentSlideNumber * 2 + 1)}-${data!.pages.length - currentSlideNumber * 2}`;
                    } else if (data!.pages.length - currentSlideNumber * 2 === 1) {
                        return `${data!.pages.length - currentSlideNumber * 2}`;
                    } else if ((data!.pages.length - currentSlideNumber * 2) % 2 !== 0) {
                        return `${data!.pages.length - (currentSlideNumber * 2 + 1)}-${data!.pages.length - currentSlideNumber * 2}`;
                    } else {
                        return `${data!.pages.length - currentSlideNumber * 2}-${data!.pages.length - currentSlideNumber * 2 + 1}`;
                    }
                } else {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length}`
                    }
                    return `${data!.pages.length - currentSlideNumber}`
                }
            }
        }
    }
    const renderCount = () => {
        if (isMobile || isTablet || isPortraitView || (isVerticalScrolling && isOnePageOrientation)) {
            return `${currentSlideNumber + 1} / ${data!.pages.length}`
        } else if (isVerticalScrolling && !isOnePageOrientation) {
            if (currentSlideNumber === 0) {
                if(data!.pages.length === 2){
                    return `${currentSlideNumber + 1}-${data!.pages.length} / ${data!.pages.length}`;
                }
                return `${currentSlideNumber + 1} / ${data!.pages.length}`;
            } else if (currentSlideNumber * 2 === data!.pages.length) {
                return `${currentSlideNumber * 2} / ${data!.pages.length}`;
            } else if (currentSlideNumber * 2 > data!.pages.length) {
                return `${data!.pages.length} / ${data!.pages.length}`;
            } else {
                return `${currentSlideNumber * 2}-${currentSlideNumber * 2 + 1} / ${data!.pages.length}`;
            }
        } else {
            if (!isHebrewStyle) {
                if (!isOnePageOrientation) {
                    if (currentSlideNumber === 0) {
                        if(data!.pages.length === 2){
                            return `${currentSlideNumber + 1}-${data!.pages.length} / ${data!.pages.length}`;
                        }
                        return `${currentSlideNumber + 1} / ${data!.pages.length}`;
                    } else if (currentSlideNumber * 2 === data!.pages.length) {
                        return `${currentSlideNumber * 2} / ${data!.pages.length}`;
                    } else if (currentSlideNumber * 2 > data!.pages.length) {
                        return `${data!.pages.length} / ${data!.pages.length}`;
                    } else {
                        return `${currentSlideNumber * 2}-${currentSlideNumber * 2 + 1} / ${data!.pages.length}`;
                    }
                } else {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length} / ${data!.pages.length}`
                    }
                    return `${currentSlideNumber + 1} / ${data!.pages.length}`
                }
            } else {
                if (!isOnePageOrientation) {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length} / ${data!.pages.length}`
                    } else if (data!.pages.length === 2) {
                        return `${currentSlideNumber + 1}-${data!.pages.length} / ${data!.pages.length}`;
                    } else if (currentSlideNumber * 2 === data!.pages.length) {
                        return `${(data!.pages.length - currentSlideNumber * 2) === 0 ? 1 : data!.pages.length - currentSlideNumber * 2} / ${data!.pages.length}`;
                    } else if (currentSlideNumber === 0 && data!.pages.length % 2 !== 1) {
                        return `${data!.pages.length} / ${data!.pages.length}`;
                    } else if (currentSlideNumber === 0 && data!.pages.length % 2 === 1) {
                        return `${data!.pages.length - (currentSlideNumber * 2 + 1)}-${data!.pages.length - currentSlideNumber * 2} / ${data!.pages.length}`;
                    } else if (data!.pages.length - currentSlideNumber * 2 === 1) {
                        return `${data!.pages.length - currentSlideNumber * 2} / ${data!.pages.length}`;
                    } else if ((data!.pages.length - currentSlideNumber * 2) % 2 !== 0) {
                        return `${data!.pages.length - (currentSlideNumber * 2 + 1)}-${data!.pages.length - currentSlideNumber * 2} / ${data!.pages.length}`;
                    } else {
                        return `${data!.pages.length - currentSlideNumber * 2}-${data!.pages.length - currentSlideNumber * 2 + 1} / ${data!.pages.length}`;
                    }
                } else {
                    if (data!.pages.length === 1) {
                        return `${data!.pages.length} / ${data!.pages.length}`
                    }
                    return `${data!.pages.length - currentSlideNumber} / ${data!.pages.length}`
                }
            }
        }
    }

    const onUnFocusInput = () => {
        changeInputTypeToNumber(false);
    }

    const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        e.target.select();
    }

    const onScrollToPage = (goToPageIndex: number, animation: boolean = false) => {
        const contentContainer = document.getElementById(`mainSliderWrapper`);
        if (contentContainer) {
            scrollToPageForFlyer(contentContainer, goToPageIndex, animation);
        }
    }

    const goToLastPage = (e: React.MouseEvent<HTMLButtonElement>) => {
        // e.preventDefault();
        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.disabled) {
            // pageFlip();
            // resetZooming();
            if(data){
                if(isVerticalScrolling && setPageRangeInUrl){
                    onScrollToPage(!isOnePageOrientation ? Math.floor((data.pages.length) / 2) : data.pages.length - 1, true);
                    setPageRangeInUrl(!isOnePageOrientation ? Math.floor((data.pages.length) / 2) : data.pages.length - 1);
                    // onScrollToPage(isMultipage && !isOnePageOrientation ? Math.floor((data.pages.length) / 2) : data.pages.length - 1);
                    // dispatch(changeCarouselActiveSlide(isMultipage && !isOnePageOrientation ? Math.floor((data.pages.length) / 2) : data.pages.length - 1))
                } else {
                    if(sliderRef && sliderRef.current){
                        (sliderRef.current as any).slickGoTo(!isOnePageOrientation ? Math.floor((data.pages.length) / 2) : data.pages.length - 1, true);
                    }
                    // dispatch(changeCarouselActiveSlide(isMultipage && (isVerticalScrolling && !isOnePageOrientation) ? Math.floor((data.pages.length) / 2) : data.pages.length - 1))
                }
            }
        }
    }
    const goToFirstPage = (e: React.MouseEvent<HTMLButtonElement>) => {
        // e.preventDefault();
        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.disabled) {
            // pageFlip()
            // resetZooming();
            if (isVerticalScrolling && setPageRangeInUrl) {
                onScrollToPage(0, true);
                setPageRangeInUrl(0);
                // onScrollToPage(0);
                // dispatch(changeCarouselActiveSlide(0));
            } else {
                if(sliderRef && sliderRef.current){
                    (sliderRef.current as any).slickGoTo(0, true);
                }
                // dispatch(changeCarouselActiveSlide(0))
            }
        }
    }
    const goToNextPage = (e: React.MouseEvent<HTMLButtonElement>) => {
        // e.preventDefault();
        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.disabled) {
            // pageFlip();
            const decreaseValue = !isOnePageOrientation ? 0 : 1;
            if (data) {
                let length = data.pages.length
                if (!isOnePageOrientation) {
                    length = Math.floor(length / 2);
                }
                if (length - decreaseValue > currentSlideNumber) {
                    // resetZooming()
                    if (isVerticalScrolling && setPageRangeInUrl) {
                        onScrollToPage(currentSlideNumber + 1, true);
                        setPageRangeInUrl(currentSlideNumber + 1);
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber + 1));
                    } else {
                        if(sliderRef && sliderRef.current){
                            (sliderRef.current as any).slickGoTo(currentSlideNumber + 1);
                        }
                        // dispatch(changeCarouselActiveSlide(currentSlideNumber + 1));
                    }
                }
            }
        }
    }
    const goToPrevPage = (e: React.MouseEvent<HTMLButtonElement>) => {
        // e.preventDefault();
        e.preventDefault();
        e.stopPropagation();
        if (!e.currentTarget.disabled) {
            // pageFlip()

            if (currentSlideNumber > 0) {
                // resetZooming()
                if (isVerticalScrolling && setPageRangeInUrl) {
                    onScrollToPage(currentSlideNumber - 1, true);
                    setPageRangeInUrl(currentSlideNumber - 1);
                    // dispatch(changeCarouselActiveSlide(currentSlideNumber - 1));
                } else {
                    if(sliderRef && sliderRef.current){
                        (sliderRef.current as any).slickGoTo(currentSlideNumber - 1);
                    }
                    // dispatch(changeCarouselActiveSlide(currentSlideNumber - 1));
                }
            }
        }
    }

    let isShowControls = (!isFullScreen && !isMobile && !isTablet && !isPortraitView && data?.pages.length !== 1 && !(!isOnePageOrientation && data?.pages.length === 2)) ;

    if (data) {
        return (
            <Grid container alignItems={`center`} className={classes.paginationWrapper} columns={24}>
                {
                    isShowControls &&
                    <Grid item
                          xs={data?.pages.length > 99 ? data?.pages.length > 999 ? 7 : 8 : 9}
                          md={data?.pages.length > 99 ? data?.pages.length > 999 ? 5 : 6 : 7}
                          lg={data?.pages.length > 99 ? data?.pages.length > 999 ? 6 : 7 : 8}
                          xl={data?.pages.length > 99 ? data?.pages.length > 999 ? 7 : 8 : 9}
                    >
                        <Grid container justifyContent={'flex-end'} columns={12}>
                            <Grid item>
                                <Box className={`${classes.paginationBox} ${classes.paginationBtn}`}>
                                    <Button
                                        title={isHebrewStyle && !isVerticalScrolling ? toLastSlide : toFirstSlide}
                                        disabled={isHebrewStyle && !isVerticalScrolling ? disabledNextButtons : disabledPrevButton}
                                        className={`action_slider_btn`}
                                        onClick={goToFirstPage}
                                    >
                                        {
                                            isVerticalScrolling ? <DoubleChevronUp/> : <DoublechevronLeft/>
                                        }

                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box className={`${classes.paginationBox} ${classes.paginationBtn}`}>
                                    <Button
                                        title={isHebrewStyle && !isVerticalScrolling ? toNextSlide : toPrevSlide}
                                        disabled={isHebrewStyle && !isVerticalScrolling ? disabledNextButtons : disabledPrevButton}
                                        className={`action_slider_btn`}
                                        onClick={goToPrevPage}
                                    >
                                        {isVerticalScrolling ? <ChevronUp/> : <ChevronLeft/>}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid item xs>
                    { isShowControls &&
                        <Grid container columns={24} justifyContent={`center`} sx={{padding: '0 4px'}} columnSpacing={"4px"}>
                            <Grid item xs>
                                <Box>
                                    <Input
                                        onFocus={onFocus}
                                        onBlur={onUnFocusInput}
                                        onChange={sortInputNumbers}
                                        type={isInputNumber ? `number` : `string`}
                                        value={paginationValue}
                                        onKeyDown={handleKeyDown}
                                        disableUnderline
                                        inputProps={{ 'aria-label': 'page number' }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={5} lg={9} xl={9} md={9}>
                                <Box sx={{
                                    display: `flex`,
                                    alignItems: `center`,
                                    height: `100%`,
                                }}>
                                    <Typography fontSize={"18px"} fontWeight={700} color={'#ffffff'} title={`${data!.pages.length}`}>
                                        {`/ ${data!.pages.length}`}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    }
                    {
                        !isShowControls &&
                        <Box className={classes.paginationBox}>
                            <Typography fontSize={data?.pages.length < 999 ? "18px" : "16px"} fontWeight={700} color={isLightGuiColor ? fontsGuiColor : `#FFFFFF`}>
                                {renderCount()}
                            </Typography>
                        </Box>
                    }
                </Grid>
                {
                    isShowControls &&
                    <Grid item
                          xs={data?.pages.length > 99 ? data?.pages.length > 999 ? 7 : 8 : 9}
                          md={data?.pages.length > 99 ? data?.pages.length > 999 ? 5 : 6 : 7}
                          lg={data?.pages.length > 99 ? data?.pages.length > 999 ? 6 : 7 : 8}
                          xl={data?.pages.length > 99 ? data?.pages.length > 999 ? 7 : 8 : 9}
                    >
                        <Grid container justifyContent={'flex-start'} columns={12}>
                            <Grid item>
                                <Box className={`${classes.paginationBox} ${classes.paginationBtn}`}>
                                    <Button
                                        title={isHebrewStyle && !isVerticalScrolling ? toPrevSlide : toNextSlide}
                                        disabled={isHebrewStyle && !isVerticalScrolling ? disabledPrevButton : disabledNextButtons}
                                        className={`action_slider_btn`}
                                        onClick={goToNextPage}
                                    >
                                        {isVerticalScrolling ? <ChevronDown/> : <ChevronRight/>}
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box className={`${classes.paginationBox} ${classes.paginationBtn}`}>
                                    <Button
                                        title={isHebrewStyle && !isVerticalScrolling ? toFirstSlide : toLastSlide}
                                        disabled={isHebrewStyle && !isVerticalScrolling ? disabledPrevButton : disabledNextButtons}
                                        className={`action_slider_btn`}
                                        onClick={goToLastPage}
                                    >
                                        { isVerticalScrolling ? <DoubleChevronDown/> : <DoublechevronRight/> }
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        );
    }
    return null;
}